import { TripEventType } from 'app/constants/delegation/tripEventType'

export const getTripEventTypeName = (
  tripEventType: TripEventType,
  translate: (string) => string,
): string => {
  const text: string = TripEventType[tripEventType]
  return translate(`tripEventType.${text}`)
}


